import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

import { Fire, Tools } from '../../../services'

import Switch from 'react-switch'
import { Headerbar, FormInput, Loader, EditContainer, ConfirmLink, Select, ImagesPicker } from '../../Reusable'

import FadeIn from 'react-fade-in';

const { useHistory } = require('react-router-dom')

const opts = [
  { value: 'super_admin', label: "Super administrateur" },
  { value: 'admin', label: 'Administrateur' },
]

interface Props {
  match: any;
}
const AdminScreen: React.FC<Props> = (props) => {

  const [error, setError] = React.useState('')
  const history = useHistory()
  
  const onFetch = async (id: string) => {
    setError('')
    try {
      const ref = Fire.store().collection('admins').doc(id)
      const element = await Fire.doc(ref)
      return element
    } catch (err) {
      setError("Impossible de charger l'admin")
      console.warn(err)
    }
    return null
  }

  const onSave = async (item: any, pictures: any[]) => {
    const data = {
      ...item
    }
    setError('')

    try {
      if (item.id) {
        await Fire.store().collection('admins').doc(item.id).update(data)
      }
      else {
        const res = await Fire.cloud('createAdmin', { info: data })
        if (res.error) {
          let error = ''
          switch (res.code) {
            case "auth/invalid-email":
              error = 'Le mail entré est invalide'
              break;

            case "auth/email-already-exists":
              error = 'Le mail entré est déjà utilisé'
              break;

            case "auth/invalid-password":
              error = 'Le mot de passe est trop faible (6 minimum)'
              break;

            default:
              error = 'Vérifiez votre connexion internet'
              break;
          }
          setError(error)
          console.log(res)
        } else {
          history.push('/admin/admins')
        }
      }
    } catch (err) {
      console.warn(err)
      setError('Vérifiez votre connexion internet')
    }
  }

  const onRemove = async (item: any) => {
    setError('')
    try {
      await Fire.store().collection('admins').doc(item.id).delete()
      history.push('/admin/admins')
    } catch (err) {
      setError("Impossible de supprimer l'admin")
      console.warn(err)
    }
  }

  const renderContent = ({item, onChange, save, saving, changed, remove, setChanged}) => {
    return (
      <>
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Informations</h3>
          </div>
          <div className="card-body">
            <div className="item-add-form">

              <div style={{marginTop: 10, marginBottom: 10}} className="title">Choisir le rôle</div>
              <div style={{marginBottom: 20}}>
                <Select
                  value={item.role}
                  onChange={(role) => onChange('role', role)}
                  options={opts}
                />
              </div>

              <FormInput
                type="text"
                placeholder="Nom et prénom"
                value={item.name}
                onChange={(evt: any) => onChange('name', evt.target.value)}
              />

              <FormInput
                type="text"
                placeholder="Intitulé du poste"
                value={item.intro}
                onChange={(evt: any) => onChange('intro', evt.target.value)}
                />

              <FormInput
                type="text"
                placeholder="Email du compte"
                value={item.email}
                onChange={(evt: any) => onChange('email', evt.target.value)}
                />

              { !item.id &&
                <FormInput
                  type="password"
                  placeholder="Mot de passe du compte"
                  value={item.password}
                  onChange={(evt: any) => onChange('password', evt.target.value)}
                  />
              }

              <FormInput
                textarea
                rows={6}
                type="text"
                placeholder="Description détaillée de la mission"
                value={item.description}
                onChange={(evt: any) => onChange('description', evt.target.value)}
                /> 
            </div>

            <div className="centered">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={save}
                disabled={saving || !changed}
                >
                { saving ? 'Chargement...' : 'Enregistrer' }
              </button>
            </div>
          </div>
        </div>
        { item.id !== undefined &&
          <div className="centered">
            <ConfirmLink
              title='Supprimer'
              className='btn-remove'
              confirmTitle='Êtes-vous sûr de vouloir supprimer cet administrateur ?'
              onPress={remove}
              />
          </div>
        }
      </>
    )
  }

  return (
    <EditContainer
      id={props.match.params.id}
      error={error}

      onFetch={onFetch}
      onSave={onSave}
      onRemove={onRemove}
      renderContent={renderContent}
      />
  );
}

export default withRouter(AdminScreen)
